import React from 'react';
import PropTypes from 'prop-types';

import classes from './Input.module.css';

export const MiddleName = (props) => {
    const { changed, blurred, clicked, middleNameState, disable } = props
    const data = {
        config: {
            id: "middleName",
            type: 'text',
            label: 'Middle Name',
            optional: '[ Optional ]'
        },
        change: (event) => changed(event, 'middleName'),
        blur: () => blurred('middleName'),
        click: (event) => clicked(event)
    }

    let inputElement = null;
    const inputClasses = [classes.InputElement];
    const errorId = `${data.config.id}_error`;

    if (!middleNameState.valid && middleNameState.touched) {
        inputClasses.push(classes.Invalid);
    }

    inputElement = <input
        id={data.config.id}
        type={data.config.type}
        className={`analytics-form-fields ${inputClasses.join(' ')}`}
        value={middleNameState.value}
        onChange={data.change}
        aria-describedby={errorId}
        aria-invalid={!!middleNameState.errMsg}
        onBlur={data.blur}
        onClick={clicked ? data.click: ""}
        readOnly= {disable} />;

    return (
        <div className={classes.Input}>
            <label className={classes.Label} htmlFor={data.config.id}>{data.config.label}<span className={classes.optional}>{data.config.optional}</span></label>
            {inputElement}
            {middleNameState.errMsg ? <p className={classes.errMsg} aria-live="polite" aria-atomic="true"  id={errorId}>{middleNameState.errMsg}</p> : null}
        </div>
    );

};

MiddleName.propTypes = {
    middleNameState: PropTypes.shape({
        value: PropTypes.string,
        errMsg: PropTypes.string,
        valid: PropTypes.bool,
        touched: PropTypes.bool,
        rules: PropTypes.shape({
            maxLength: PropTypes.number,
            pattern: PropTypes.instanceOf(RegExp),
            patternMessage: PropTypes.string
        })
    }),
    disable: PropTypes.bool,
    changed: PropTypes.func,
    blurred: PropTypes.func
}

MiddleName.defaultProps = {
    middleNameState: {
        value: '',
        errMsg: null,
        valid: true,
        touched: false,
        rules: {
            maxLength: 30,
            pattern: '^[a-zA-Z]*$',
            patternMessage: 'Should contain only Alphabets'
        }
    },
    disable: false,
    changed: () => { },
    blurred: () => { }
}

export default MiddleName;